import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-gray-700 text-center" }
const _hoisted_2 = { class: "my-3 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseModal = _resolveComponent("BaseModal")!

  return (_openBlock(), _createBlock(_component_BaseModal, {
    class: "p-3",
    open: _ctx.redirectModal.isOpen,
    "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.redirectModal.isOpen) = $event)),
    closable: false
  }, {
    default: _withCtx(() => [
      _cache[2] || (_cache[2] = _createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        class: "text-primary-main opacity-25 w-1/2 mx-auto"
      }, [
        _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.redirectModal.message), 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_BaseButton, {
          buttonClass: "outlined",
          onClick: _ctx.redirectUrlLinkTo
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("画面が遷移しない場合はこちら", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}